module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0484-min.e5bdaa12.jpg";